enum EnvKeys {
  BACKEND_BASE_URL = "BACKEND_BASE_URL",
  LOGGING = "LOGGING",
  TIMEOUT_MS = "TIMEOUT_MS",
}

export default EnvKeys;
